import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {ConfigProvider} from 'antd';
import plPL from 'antd/locale/pl_PL';
import App from './App';
import './index.css';

/* Strona nie loguje nikogo, więc nie ma tu kontekstu użytkownika, logowania
   Google ani WebSocketu z powiadomieniami. To wszystko żyje w aplikacji mobilnej. */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider
        locale={plPL}
        theme={{
          token: {
            colorPrimary: '#DB7093',
            borderRadius: 8,
          },
        }}
      >
        <App />
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);
